//region :: Imports ::
import React, {ReactElement} from 'react';
import MComponent from '../Components/Component';
import MButton from '../Components/Controls/Button';
import {LoginIconName} from '../Icons';
import WithRouterProps from '../WithRouterProps';
import withRouter from '../WithRouter';
import TemplateOne from '../Templates/TemplateOne';

//endregion

/** */
type Props = WithRouterProps & {};

/** */
class LogoutPage extends MComponent<Props> {

    /** */
    public constructor(props: Props) {
        super(props);
        this.bindMethods();
    }

    /** */
    private bindMethods(): void {
        this.loginButton_onClick = this.loginButton_onClick.bind(this);
    }

    /** */
    private loginButton_onClick(): void {
        this.props.navigate('/');
    }

    /** */
    public render(): ReactElement {

        return (
            <TemplateOne title="Logout Sucessful"
                         message="You can now close the tab or click the button below to log in again.">

                <MButton label="Log In"
                         icon={LoginIconName}
                         disabled={false}
                         onClick={this.loginButton_onClick}/>

            </TemplateOne>
        );

    }

}

export default withRouter(LogoutPage);
